module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAANCAYAAAHu22/pAAAAAXNSR0IArs4c6QAAAN1JREFUKBVtkMERwiAQRSHHVODdq+PREtIKdBQ4UYdetYSMLaQDr3E/4TMLSWbMkr/v/100McbJ8AkhfPJZ1GDyS7eqkFK6qMab57YKPmbleCBYBxYBEyqtoPUg9qQk7WugQaeuok+40tgDzQ4aaBqMAiCNld+oAz+2bXtZa68CRGq56qiSsAO6QQeAeZ4fRuIGACKcXokGVDBg4bFsIKnstDjnPHUapHeTfSfp/aBVI0EdAK03kKv/AAUkSvIihjt+OHMKGdRmIu7QTygbPIX9eu8dzdl4ZiDA2gf8AfJzrHeQZ9rwAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/common/img/phoneLoginClose.png
// module id = Q0xn
// module chunks = 25